import type { ViewType } from '@/app/api/placements/types'
import type { DeviceType } from '@/app/util/env'

export const FREESTAR_SLOT_NAMES = {
    desktopStickyFooter: 'giphy-com_desktop_sticky_footer',
    desktopStickyRailRight: 'giphy-com_desktop_sticky_rail_right',
    desktopStickySidewallRight: 'giphy-com_desktop_sticky_sidewall_right',
    mobileStickyPushdown: 'giphy-com_mobile_sticky_pushdown',
} as const

export const MOBILE_STICKY_PUSHDOWN_NAVBAR_MOUNT_ID = 'giphy-com-mobile-sticky-pushdown-navbar-mount'

export type FreestarSlotName = (typeof FREESTAR_SLOT_NAMES)[keyof typeof FREESTAR_SLOT_NAMES]

export type FreestarSlotKind = 'sticky_footer' | 'sticky_rail_right' | 'sticky_sidewall_right' | 'mobile_pushdown'

export type FreestarSlotConfig = {
    kind: FreestarSlotKind
    placementName: FreestarSlotName
    slotId: FreestarSlotName
    dataFreestarAd?: string
    renderTargetId?: string
    reservedHeight?: number
    reservedWidth?: number
}

export type FreestarResponseContext = {
    view: ViewType | 'style_guide' | 'explore_results' | 'media'
    deviceType: DeviceType
}

export type FreestarSuppressionReason =
    | 'backend_not_cleared'
    | 'provider_placement'
    | 'query_param'
    | 'missing_slot'
    | 'consent_suppressed'
    | 'didomi_unavailable'
    | 'runtime_error'
    | 'script_error'

export type FreestarSuppressedOpportunity = {
    status: 'suppressed'
    reason: FreestarSuppressionReason
    backendCleared: boolean
    context: FreestarResponseContext
}

export type FreestarReadyOpportunity = {
    status: 'ready'
    backendCleared: true
    context: FreestarResponseContext
    slots: FreestarSlotConfig[]
}

export type FreestarOpportunity = FreestarSuppressedOpportunity | FreestarReadyOpportunity

export type FreestarTelemetryState =
    | FreestarSuppressionReason
    | 'attempt'
    | 'script_loaded'
    | 'slot_invoked'
    | 'slot_filled'
    | 'slot_empty'
